export default {
    authUser(state, value){
        if(value){
            state.auth.error = null;
        }
        state.auth.user = value;
    },
    updateJwt(state, value){
        state.auth.jwt = value;
    },
    authUserRemove(state, value){
        state.auth.user = null;
        state.auth.jwt = null;
    },
    authError(state, value){
        state.auth.error = value;
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js